import requests, { convertToFormData } from "@/api/request";

/**
 * 上传文件
 * @param {Number} MID 当前菜单ID
 * @param {String} instanceID 实例对像ID
 * @param {Function} callback callback 回调方法
 */
export function PostFile(category, file) {
  const data = convertToFormData({
    category,
    file,
  });
  return requests({
    url: "/General/UploadFile",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
    method: "post",
    data,
  });
}

export function GetPayAccount(params) {
  return requests({
    url: "/ServiceApi/PayAccount",
    method: "Get",
    params,
  });
}

export function GetGoodsView(params) {
  return requests({
    url: "/ServiceApi/GetGoodsView",
    method: "Get",
    params,
  });
}
export function GetServiceAgreement(params) {
  return requests({
    url: "/ServiceApi/ServiceAgreementView",
    method: "Get",
    params,
  });
}
export function GetCrossFlowList(params) {
  return requests({
    url: "/CrossBorderApi/FlowList",
    method: "Get",
    params,
  });
}

export function GetServiceNo(params) {
  return requests({
    url: "/CrossBorderApi/GetServiceNo",
    method: "Get",
    params,
  });
}
export function GetItemDetailList(params) {
  return requests({
    url: "/Data/GetItemDetailList",
    method: "Get",
    params,
  });
}
export function RceivingSampleLabView(params) {
  return requests({
    url: "/ServiceApi/RceivingSampleLabView",
    method: "Get",
    params,
  });
}
export function OrderSendSampleView(params) {
  return requests({
    url: "/ServiceApi/GetOrderSendSample",
    method: "Get",
    params,
  });
}
export function GetDataSourceList(params) {
  return requests({
    url: "/Data/GetDataSourceList",
    method: "Get",
    params,
  });
}
export function GetTotalPrice(params) {
  return requests({
    url: "/ServiceApi/GetTotalPrice",
    method: "Get",
    params,
  });
}
export function GetUserCenterIndexCount(params) {
  return requests({
    url: "/ServiceApi/IndexCount",
    method: "Get",
    params,
  });
}

export function GetOrderInfo(ID, IsEdit) {
  return requests({
    url: "/ServiceApi/GetOrderView",
    method: "Get",
    params: { ID, IsEdit },
  });
}

export function SaveGoodsOrder(data) {
  return requests({
    url: "/ServiceApi/SaveGoodsOrder",
    method: "Post",
    data,
  });
}
export function SaveOrderFile(data) {
  return requests({
    url: "/ServiceApi/SaveOrderFile",
    method: "Post",
    data,
  });
}
/**
 * 是否登录
 * @param {*} data 
 * @returns 
 */
export function IsLogin(token) {
  return requests({
    url: "/User/IsLogin",
    method: "Post",
    data:{
      token
    },
  });
}
/**
 * 提交订单支付
 * @param {*} data 
 * @returns 
 */
export function SubmitOrderPay(data) {
  return requests({
    url: "/ServiceApi/OrderPay",
    method: "Post",
    data,
  });
}
/**
 * 提交订单评价
 * @param {*} data 
 * @returns 
 */
export function SubmitOrderEvaluate(data) {
  return requests({
    url: "/ServiceApi/OrderEvaluate",
    method: "Post",
    data,
  });
}
export function UpdateGoodsOrder(data) {
  return requests({
    url: "/ServiceApi/UpdateGoodsOrder",
    method: "Post",
    data,
  });
}

export function SaveOrderStatus(data) {
  return requests({
    url: "/ServiceApi/SaveOrderStatus",
    method: "Post",
    data,
  });
}
// 手机验证码
export function Code(data) {
  return requests({
    url: "/User/CodeXed",
    method: "Post",
    data,
  });
}

// 判断是否重复  /General/GetIsExist
export function GetIsExist(data) {
  return requests({
    url: "/General/GetIsExist",
    method: "get",
    data,
  });
}

///User/SaveReg 保存用户注册信息
export function SaveReg(data) {
  return requests({
    url: "/User/SaveReg",
    method: "Post",
    data,
  });
}

// /User/EditPsw 修改密码   这个是修改密码不是忘记密码
export function EditPsw(data) {
  return requests({
    url: "/User/EditPsw",
    method: "Post",
    data,
  });
}

//  /User/ResetPsw  找回密码
export function ResetPsw(data) {
  return requests({
    url: "/User/ResetPsw",
    method: "Post",
    data,
  });
}

// /User/Login 登录
export function Login(data) {
  return requests({
    url: "/User/Login",
    method: "Post",
    data,
  });
}
// /User/Login 登录
export function Logout(data) {
  return requests({
    url: "/User/Logout",
    method: "Post",
    data,
  });
}
/**
 * 手机验证码登录
 * @param {{PhoneNo:String,Code:String}} data 
 * @returns 
 */
 export function PhoneLogin(data) {
  return requests({
    url: "/User/PhoneLogin",
    method: "Post",
    data,
  });
}

// /General/GetList 获取列表数据
export function GetList(data) {
  return requests({
    url: "/General/GetList",
    method: "get",
    data,
  });
}

// /General/GetView  获取单条数据
export function GetView(data) {
  return requests({
    url: "/General/GetView",
    method: "get",
    data,
  });
}

// /General/Add 新增
export function Add(data) {
  return requests({
    url: "/General/Add",
    method: "Post",
    data,
  });
}

// /General/Edit  编辑一条
export function Edit(data) {
  return requests({
    url: "/General/Edit",
    method: "Post",
    data,
  });
}

// /General/Del  删除一条
export function Del(data) {
  return requests({
    url: "/General/Del",
    method: "Post",
    data,
  });
}

// /General/UserRecharge  用户充值
export function UserRecharge(data) {
  return requests({
    url: "/General/UserRecharge",
    method: "Post",
    data,
  });
}

// 草稿报告确认通过
export function TempReprotPass(data) {
  return requests({
    url: "/ServiceApi/TempReprotPass",
    method: "Post",
    data,
  });
}
// 草稿报告确认不通过
export function TempReprotNoPass(data) {
  return requests({
    url: "/ServiceApi/TempReprotNoPass",
    method: "Post",
    data,
  });
}

// 开票信息编辑
export function OrderInvoiceEdit(data) {
  return requests({
    url: "/ServiceApi/OrderInvoiceEdit",
    method: "Post",
    data,
  });
}

// 删除发票
export function OrderInvoiceDel(data) {
  return requests({
    url: "/ServiceApi/OrderInvoiceDel",
    method: "Post",
    data,
  });
}

// 退款信息编辑
export function OrderRefundEdit(data) {
  return requests({
    url: "/ServiceApi/OrderRefundEdit",
    method: "Post",
    data,
  });
}

// 生成协议书
export function GenerateXYS(data) {
  return requests({
    url: "/ServiceApi/GenerateAgreement",
    method: "Post",
    data,
  });
}

// 退款信息删除
export function OrderRefundDel(data) {
  return requests({
    url: "/ServiceApi/OrderRefundDel",
    method: "Post",
    data,
  });
}

// 获取历史订单列表（用于引用订单信息）
export function GetHistoryOrderList(params) {
  return requests({
    url: "/ServiceApi/GetHistoryOrderList",
    method: "Get",
    params,
  });
}

// 草稿报告确认
export function DemoReporConfirm(data) {
  return requests({
    url: "/ServiceApi/DemoReporConfirm",
    method: "Post",
    data,
  });
}

export default {
  TempReprotPass,
  TempReprotNoPass,
  Del,
  GetView,
  Edit,
  Add,
  Code,
  SaveReg,
  GetIsExist,
  EditPsw,
  Login,
  PhoneLogin,
  GetList,
  ResetPsw,
  UserRecharge,
  DemoReporConfirm,
};
